import React from "react";

const hardik_mutha = () => {
  return (
    <div>
      <h1>Hardik Mutha</h1>

      <h4>
        <em>
          Computer Engineering, Batch of 27'
          <br />
          <hr />
        </em>
      </h4>

      <p>
        <strong>
          What was the criteria for shortlisting candidates in the initial
          stages of the recruitment process
        </strong>
        ?<br />
        Shortlisting Criteria for the aptitude round -
      </p>

      <ul>
        <li>Branch - Computer, ENTC, Electrical </li>
        <li>CGPA - Min. 7</li>
      </ul>

      <p>
        In addition to applying on the superset portal, students had to also
        fill an ATS form on UBS’s portal. Apart from this, UBS also conducted a
        Hackathon a few months ago. All the finalists of the hackathon were
        directly shortlisted for the interview without aptitude round.
      </p>

      <p>
        <strong>What was the Timeline of the entire Interview Process</strong>?
        <br />
        The company conducted its Pre-Placement Talk on 1st August, followed by
        the Aptitude Test, which was held immediately afterward in the Cognizant
        Lab. The shortlist for interviews was announced on 4th August, and the
        interviews were conducted the very next day.
      </p>

      <p>
        <strong>What was the Structure of the Aptitude Round?</strong>
        <br />
        Since I was one of the finalists in the hackathon I was exempted from
        the aptitude test. But everyone was supposed to give an{" "}
        <strong>Aon assessment</strong> (which had questions to check your
        mental evaluation skills) and a <strong>Cultural Fitment Test</strong>{" "}
        (this had some scenario based questions to check your team work and
        collaboration skills). The Aon Test &amp; Cultural Fit Test was
        conducted on UBS’s own platform and we had <strong>7 days</strong> from
        the date of application to complete these tests.
      </p>

      <p>
        <strong>
          How many students were shortlisted after the Aptitude Round?
        </strong>
        <br />
        Around 155 students gave the Aptitude Test, out which 9 were shortlisted
        for the interviews. Out of these 9 candidates 3 were from Hackathon
        (Direct Interviews) and 6 were selected from the Aptitude Test.
      </p>

      <p>
        <strong>
          After being shortlisted, how long was the wait time before the
          interviews began? During this period, what specific areas did you
          focus on to prepare effectively?
        </strong>
        <br />
        The shortlist was announced on 4th August, and the interviews were
        scheduled for the very next day.
        <br />
        Since there was limited time, I primarily relied on the preparation I
        had done during my vacation.
        <br />
        I thoroughly reviewed my resume and projects, revised important concepts
        from DBMS and Operating Systems, and brushed up on the technologies I
        had worked with in my projects. Additionally, I reflected on the
        mistakes I had made in my previous interviews to ensure I didn’t repeat
        them. I prepared a brief introduction about my projects to ensure that I
        don't miss out on the details.
        <br />I also went through the company’s principles and core values
        discussed during the pre-placement talk, which proved helpful during the
        HR round.
      </p>

      <p>
        <strong>
          How many Interview Rounds were there for the company, can you
          elaborate about each round in brief? Also mention, how many students
          were shortlisted after each Interview Round?
        </strong>
        <br />
        There were two interview rounds - 1 Technical &amp; 1 HR.
        <br />
        After the technical round 3 students were shortlisted for the HR Round
        and after HR round 2 were given the final offer.
        <br />
        Students were called at the Placement cell at 9 am. Placement Interviews
        were taken before Internship Interviews, so our interviews actually
        started around 1 pm.
      </p>

      <ol>
        <li>Technical Round - </li>
      </ol>

      <ul>
        <li>
          The technical round was held in the main building in one of the
          interview cabins . It lasted for about 30-35 mins. The panel had two
          interviewers and the interview started with my introduction. The
          interviewer initially saw the name of my school (Bishops) and asked
          about it. This first interaction helped calm my nerves and made me
          feel comfortable.{" "}
        </li>
        <li>
          Then they moved to my projects. I was questioned deeply on my DSA
          project. They started with the algorithms which were used in the
          project. I was asked to write down the pseudo code for the same. Then
          they asked about N-grams and also about the concept of Jaccard
          Similarity (both of these concepts were used in my projects). Later,
          the discussion shifted toward the practical applications of my
          project. The interviewer presented a specific scenario and asked how
          my project could be useful in that context. Since I had thoroughly
          understood my project and its real-world applications, I was able to
          explain my approach clearly and confidently. The interviewer seemed
          genuinely impressed and satisfied with my response.{" "}
        </li>
        <li>
          Next, the interviewer questioned my choice of using C as the
          programming language for my project. (Note : Answers like - “It was
          compulsory in my course work hence I used it don't work and it creates
          a bad impression on the interviewer).I was asked a question on
          monotonic stack (a modified version of next greater element) . Then I
          was questioned about my learning methods &amp; my approach to learn a
          new programming language. Finally some questions about OOP were asked.
          Overall the technical round was mostly focused on the projects in my
          resume with a few DSA questions.{" "}
        </li>
        <li>
          Towards the end of the interview, the interviewer asked if I had any
          questions. I believe this is an excellent opportunity, as asking
          thoughtful questions demonstrates genuine interest in the company. I
          asked, “As a corporate bank which deals with sensitive data, how are
          you integrating AI into your systems while addressing the security and
          privacy challenges that come with it?” The interviewer appreciated the
          depth of the question, and it led to an engaging discussion about the
          bank’s ongoing technological initiatives.
        </li>
      </ul>

      <p>
        My Technical Round was relatively concise and focused, as the
        interviewers already had access to the performance reports from the
        company’s hackathon, where I had performed well. This prior evaluation
        allowed the discussion to revolve more around my approach,
        problem-solving methods, and learnings from the hackathon. The strong
        performance during that event significantly contributed to the overall
        interview outcome.
      </p>

      <ol start="2">
        <li>
          Profit/HR Round - The HR Round was relatively short and more
          conversational compared to the technical round. It began with a
          self-introduction, followed by a few questions about my family
          background. The interviewer also asked about my work at an NGO, which
          I had mentioned in my resume. I was asked how much I knew about UBS
          (They were checking if I attended the PPT). In response, I spoke about
          the three keys in UBS’s logo and their significance. I even mentioned
          that the mentors during the hackathon were extremely helpful and that
          was a really good representation of the culture at UBS &amp; this
          motivates me to join their company. The round concluded with me asking
          a question about UBS, which led to a brief and engaging discussion.
        </li>
      </ol>

      <p>
        Overall both rounds went smoothly &amp; I was quite satisfied with my
        interview. Also my experience in the interviews of the previous
        companies helped me.
        <br />
        A good practice is to have a brief description about yourself and each
        of your projects ready so that you do not over/under speak during the
        interview.
        <br />
        Pay attention during the pre-placement talk of the company as the facts
        mentioned there are often asked in the HR round.
      </p>

      <p>
        <strong>
          What Topics or Skills did the interviewers focus on during the
          interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or
          Behavioral questions)
        </strong>
        <br />
        The Technical Interview with UBS was mostly focused on my projects. I
        was asked a few easy-medium level DSA questions based on the data
        structures used in my project (linked list &amp; BST’s &amp; stack).
        <br />
        However, in my previous interviews I was questioned extensively on DSA,
        OOPs, OS &amp; DBMS.
      </p>

      <ul>
        <li>I was asked a design question based on LRU Cache. </li>
        <li>
          A puzzle on{" "}
          <a href="https://www.geeksforgeeks.org/aptitude/puzzle-10-stack-of-10-coins/">
            Stack of Coins
          </a>{" "}
        </li>
        <li>
          <a href="https://www.geeksforgeeks.org/aptitude/puzzle-three-squares/">
            Three Squares Puzzle
          </a>{" "}
        </li>
        <li>
          Write an SQL query to find the 2nd highest salary from an employee
          table without using OFFSET and LIMIT.{" "}
        </li>
        <li>Difference between Authentication and Authorization. </li>
        <li>How does JWT work &amp; SQL vs NoSQL databases. </li>
        <li>Write down code which demonstrates runtime polymorphism. </li>
        <li>
          A few concepts from OS like dead-locks, synchronization were also
          asked.
        </li>
      </ul>

      <p>
        When explaining your approach to a problem to the interviewer, always
        start with the <strong>brute force solution</strong> first (even if you
        know the optimal answer).The interviewers are not always looking for the
        solution, they are looking at your thought process.
        <br />
        Overall they try to test your problem solving ability &amp; your
        knowledge about computer science in general.
        <br />
        Through behavioural questions they try to assess your compatibility with
        the organization, your ability to work in a team{" "}
      </p>

      <p>
        <strong>
          What are some good resources that you used in your Internship Prep?
        </strong>
        <br />
        Resources which I used are -{" "}
      </p>

      <ol>
        <li>
          DSA -{" "}
          <a href="https://takeuforward.org/strivers-a2z-dsa-course/strivers-a2z-dsa-course-sheet-2/">
            Striver’s DSA Sheet
          </a>{" "}
          &amp;{" "}
          <a href="https://www.tle-eliminators.com/cp-sheet">
            TLE Eliminators - CP-31
          </a>{" "}
          (only do this if you are comfortable with striver’s DSA Sheet). Aditya
          Verma’s Playlist for DP.{" "}
        </li>
        <li>
          OS -{" "}
          <a href="https://www.youtube.com/watch?v=w5PX6-f5pEM&list=PLI6tb_y9bRBStTZvyQVbzV9o6890HXecS">
            Abhijit Sir’s Lectures - The Sparkle
          </a>{" "}
          &amp; Operating-System-Concepts by Abraham-Silberschatz{" "}
        </li>
        <li>
          DBMS -{" "}
          <a href="https://www.youtube.com/watch?v=eYpXCdvKwEQ&list=PLDzeHZWIZsTpukecmA2p5rhHM14bl2dHU">
            Love Babbars - DBMS Series
          </a>{" "}
          , GFG Articles, Handmade notes.{" "}
        </li>
        <li>
          OOPs -{" "}
          <a href="https://www.youtube.com/watch?v=BSVKUk58K6U&list=PL9gnSGHSqcno1G3XjUbwzXHL8_EttOuKk">
            Kunal Kushawaha - OOP using Java
          </a>
          , w3 schools, JavatPoint{" "}
        </li>
        <li>Computer Networks - Abhijit Sir’s Lectures &amp; GFG Articles </li>
        <li>Puzzles - GFG Articles &amp; Interview Bit</li>
      </ol>

      <p>
        <strong>Some tips to crack Coding Questions?</strong>
        <br />
        <strong>Consistency is the key.</strong> Try to solve at least 2-3
        problems everyday. Solving daily problems on LeetCode is a really good
        way to practice as you keep getting exposed to new questions.
        Competitive Coding also helps a lot as it prepares you to think in a
        time bound situation which is often the case in OA’s. Try giving
        contests on platforms like Leecode, Codeforces and CodeChef{" "}
        <strong>irrespective</strong> of your preparation level. During OA’s
        even if you are not able to come up with an optimal solution, try to
        pass as many test cases as you can using brute force. Also write{" "}
        <strong>good and clean code</strong> because sometimes interviewers read
        your code as well before shortlisting (happened in one of the OA’s).
      </p>

      <p>
        <strong>
          How many questions were asked about Projects, Clubs, and
          Extracurricular activities in your resume
        </strong>
        ?<br />
        The entire Technical Round was centered around my projects, with most of
        the questions revolving around their implementation, challenges, and
        real-world applications.
        <br />
        The HR Round, on the other hand, focused more on my involvement in clubs
        and extracurricular activities. I was asked to describe my role as the
        President of CSI COEP and also about my contributions to the SDS club,
        where I had mentioned an ongoing project.
        <br />
        The interviewer showed particular interest in my social internship at an
        NGO, considering it a unique experience. In one of my earlier
        interviews, I was also asked to share my GitHub and LinkedIn profiles
        for a quick review.
      </p>

      <p>
        <strong>
          Is there something specific that you would want to tell people who are
          preparing for the same company
        </strong>
        ?
      </p>

      <p>
        In my case, the hackathon played a major role in helping me secure the
        offer. Although it wasn’t officially a hiring event, the mentors closely
        observed each team member’s contribution throughout the competition. The
        applications for the hackathon are usually released in the last week of
        March, so it’s important to keep an eye on your emails. Make sure to
        interact actively with your mentors and take initiative during the
        event, as it leaves a strong impression.
      </p>

      <p>
        UBS interviews are generally centered around your resume and projects,
        though the focus can vary depending on the interviewer. Also, pay close
        attention during the company’s pre-placement talk, some candidates were
        asked specific questions about it during their HR rounds.
      </p>

      <p>
        <strong>Any Final Tips for Juniors?</strong>
        <br />
        The internship season can be a challenging and unpredictable phase. At
        times, despite performing well, things might not go as expected, and
        luck can play a noticeable role in the outcome. There may be situations
        where you feel you were very close to getting an offer or even more
        deserving than someone who did. Such thoughts are natural but best
        avoided. It’s important to stay focused, keep improving, and remember
        that every interview adds to your experience and prepares you better for
        the next opportunity.
      </p>

      <p>
        Keep learning from your mistakes and try not to repeat them. Ask the
        interviewers for feedback if possible and try to improve on those
        points.
        <br />
        Do not bluff about any achievements/projects on your resume as
        interviewers are really sharp at pointing out such things.
        <br />
        There are several opportunities which will come your way and try to make
        the most of each opportunity. Don't miss out on any deadlines and keep a
        constant watch on your email. Keep discussing with your friends about
        their interview experiences, it helps a lot. All the best !!
      </p>

      <p>
        <strong>Contact Info</strong>
        <br />
        <strong>Email :</strong> <a href="mailto:hardikmutha2005@gmail.com">hardikmutha2005@gmail.com</a>
        <br />
        <strong>LinkedIn : </strong>
        <a href="https://www.linkedin.com/in/hardik-mutha08/">Hardik Mutha</a>
      </p>
    </div>
  );
};

export default hardik_mutha;
